// src/redux/services/subscription/subscription.service.js

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const stripeApi = createApi({
  reducerPath: "stripeApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api/users" }),
  endpoints: (builder) => ({
    // Create PaymentIntent
    createPaymentIntent: builder.mutation({
      query: ({ name, customer_email, interval, id, userId }) => ({
        url: "/paymentIntent",
        method: "POST",
        body: { name, customer_email, interval, id, userId },
      }),
    }),

    // Create subscription with trial
    createSubscription: builder.mutation({
      query: ({ name, email, userId, planId, interval, trial_period_days, paymentMethodId }) => ({
        url: "/create-customer-subscription",
        method: "POST",
        body: { name, customer_email: email, userId, id: planId, interval, trial_period_days, paymentMethodId },
      }),
    }),

    // Cancel subscription (old method - not used)
    cancelSubscription: builder.mutation({
      query: ({ subscriptionId, userId }) => ({
        url: "/cancelSubscription",
        method: "DELETE",
        body: { subscriptionId, userId },
      }),
    }),

    // Cancel subscription at period end (new method)
    cancelSubscriptionAtPeriodEnd: builder.mutation({
      query: (userId) => ({
        url: "/cancel-subscription",
        method: "POST",
        body: { userId },
      }),
    }),

    // Check user access
    checkAccess: builder.query({
      query: (userId) => ({
        url: `/users/check-access/${userId}`,
        method: "GET",
      }),
    }),
    
    // Sync access with Stripe
    syncAccess: builder.mutation({
      query: (userId) => ({
        url: `/sync-access/${userId}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useCreatePaymentIntentMutation,
  useCreateSubscriptionMutation,
  useCancelSubscriptionMutation,
  useCancelSubscriptionAtPeriodEndMutation,
  useCheckAccessQuery,
  useSyncAccessMutation,
} = stripeApi;
